module.exports = __webpack_public_path__ + "static/media/quote-list-dark.513abcf2.svg";